import {
  TemplatesApi,
  type InlineResponse2004,
  type MultipleChoice,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import type { MigratedTemplateBody } from '../domain/types'

export const getTemplate = (templateId: number) =>
  baseClient
    .getApi(TemplatesApi)
    .getTemplate({ templateId })
    .catch(handleHTTPError)

export const getTemplatePagesWithRule = (templateId: number) =>
  baseClient
    .getApi(TemplatesApi)
    .getTemplatePagesWithRule({ templateId })
    .catch(handleHTTPError)

export const getTemplateResponseMultipleChoices = (templateId: number) =>
  baseClient
    .getApi(TemplatesApi)
    .getTemplateResponseMultipleChoices({ templateId })
    .catch(handleHTTPError)

export const addResponseMultipleChoices = (request: {
  multipleChoice: MultipleChoice[]
  isTemplateSpecific: boolean
}) =>
  baseClient
    .getApi(TemplatesApi)
    .addResponseMultipleChoices(request)
    .catch(handleHTTPError)

export const createTemplateV3 = async (
  body: MigratedTemplateBody,
): Promise<InlineResponse2004> =>
  baseClient
    .getApi(TemplatesApi)
    .createTemplateV3({ createTemplateV3Body: body })
    .catch(handleHTTPError)
